import angular from 'angular';
import RelatedProductsComponent from './related-products.component';

let RelatedProductsModule = angular.module('catalog.relatedProducts', [])
  .component('relatedProducts', RelatedProductsComponent);

export default RelatedProductsModule;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/catalog/related-products/related-products.js
 **/